import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Buefy
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
// import 'bulma/bulma.sass';
// import 'bulmaswatch/lux/bulmaswatch.scss';

Vue.use(Buefy, {
})

// Router
import router from './router'

// Axios / HTTP
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// Charts
import Chart from 'vue2-frappe'
Vue.use(Chart)

// Numeral filter
import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });

// Auth
import auth from '@/auth/auth'
Vue.use(auth)


new Vue({
  data() {
    return {
      api_base_url: "https://insights-backend.yop.li/api/v1/"
    }
  },
  router,
  render: h => h(App)
}).$mount('#app')
